// SPDX-License-Identifier: AGPL-3.0-or-later

let cachedZoomFactor: number | null = null;
let clearZoomCacheRafId: number | null = null;

function scheduleZoomCacheClear(): void {
	if (typeof window === 'undefined' || typeof window.requestAnimationFrame !== 'function') {
		cachedZoomFactor = null;
		return;
	}
	if (clearZoomCacheRafId != null) return;
	clearZoomCacheRafId = window.requestAnimationFrame(() => {
		clearZoomCacheRafId = null;
		cachedZoomFactor = null;
	});
}

export function getAppZoomFactor(): number {
	if (typeof document === 'undefined') {
		return 1;
	}
	if (cachedZoomFactor != null) {
		return cachedZoomFactor;
	}
	const value = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--app-zoom-factor'));
	cachedZoomFactor = Number.isFinite(value) && value > 0 ? value : 1;
	scheduleZoomCacheClear();
	return cachedZoomFactor;
}

export function appZoomLayoutPx(value: number): number {
	return value / getAppZoomFactor();
}

export function appZoomCssPx(value: number): string {
	return `${appZoomLayoutPx(value)}px`;
}
